<template>
  <div
    v-swiper="swiperOptions"
    class="footer-tags swiper"
  >
    <ul class="footer-tags__list swiper-wrapper">
      <li
        v-for="item in tagsList"
        :key="item.title"
        class="footer-tags__item swiper-slide"
      >
        <UiBtn
          color="gray"
          :text="item.title"
          :to="item.path"
        />
      </li>
    </ul>
  </div>
</template>

<script>
const swiperOptions = {
  slidesPerView: 'auto',
  preventClicks: true,
  preventClicksPropagation: false,
  threshold: 12,
  slidesOffsetBefore: 16,
  slidesOffsetAfter: 16,
  breakpoints: {
    1200: {
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
    },
  },
}

export default {
  name: 'FooterTags',
  data() {
    return {
      swiperOptions: swiperOptions,
      tagsList: [
        { ...this.$pathObj.slots },
        { ...this.$pathObj.new },
        { ...this.$pathObj.forBonuses },
        { ...this.$pathObj.roulette },
        { ...this.$pathObj.blackjack },
        { ...this.$pathObj.pragmatic },
        { ...this.$pathObj.egt },
        { ...this.$pathObj.oaks },
        { ...this.$pathObj.playson },
      ],
    }
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
